import { Directive, Input, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDisableControl]',
})
export class DisableControlDirective {
  private ngControl = inject(NgControl);

  @Input() set appDisableControl(condition: boolean) {
    const action = condition ? 'disable' : 'enable';
    if (!!this.ngControl.control) this.ngControl.control[action]();
  }
}
